import { makeStyles } from '@material-ui/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'

const commonQuestionAdornments = theme => ({
  padding: 5,
  background: fade(theme.palette.secondary.main, 0.10),
  display: 'block',
  fontSize: 12,
  fontWeigth: 600,
  marginTop: '1rem',
  textAlign: 'justify',
  width: '100%',
})

export const useStyles = makeStyles((theme) => ({
  question: {
    width: '100%',
    marginBottom: '1rem',
  },
  questionWrapper: {
    width: '100%',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  questionTable: {
    marginTop: 10,
    overflowX: 'scroll',
    border: '1px solid #eee',
  },
  questionTableCell: {
    padding: 10,
    textAlign: 'center',
  },
  choiceTextHeaderCell: {
    width: '55% !important'
  },
  questionTableHeaderCell: {
    padding: 10,
    minWidth: 40,
    maxWidth: 200,
    fontSize: '12px',
    wordBrek: 'break-all',
    textAlign: 'center',
  },
  questionTableRowCell: {
    padding: 10,
    textAlign: 'left',
  },
  dimensionGroup: {
    fontSize: 20,
    fontWeight: 700,
  },
  criterionGroup: {
    fontSize: 15,
    fontWeight: 700,
    marginTop: 20,
  },
  indicatorGroup: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 20,
  },
  subtopicsGroup: {
    fontSize: 16,
    fontWeight: 600,
  },
  statement: {
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontSize: 15,
    fontWeight: 600,
    padding: 5,
  },
  choice: {
    fontSize: 15,
    cursor: 'pointer',
    transition: 'background 150ms ease',
    // '&:hover': {
    //   background: 'lightyellow !important'
    // }
  },
  iconButtonRoot: {
    borderRadius: 0
  },
  protocols: {
    ...commonQuestionAdornments(theme)
  },
  references: {
    marginBottom: '1rem',
    ...commonQuestionAdornments(theme)
  },
  documents: {
    ...commonQuestionAdornments(theme)
  },
  noQuestionsFound: {
    color: theme.palette.primary.main,
    marginBottom: '2rem'
  }
}))
